import axios from 'axios';
import { isNullOrEmpty, completedMessage } from 'src/modules/utils';

export const addConstants = ({ commit }) => {
  let url = `${process.env.VUE_APP_API_URL}surveys/constants`;

  return axios
    .get(url)
    .then(response => {
      commit('addConstants', response.data);
    });
}

export const addSurveys = ({ commit }) => {
  let url = `${process.env.VUE_APP_API_URL}surveys`;

  return axios
    .get(url)
    .then(response => {
      commit('addSurveys', response.data);
    });
}

export const addActiveSurvey = ({ commit }, payload) => {
  let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}`;
  let config = {};

  if(payload.hasOwnProperty('token')) {
    url += '/auth';
    config = {
      headers: {
        'Authorization': `Bearer ${payload.token}`
      }
    };
  }
  else if(payload.hasOwnProperty('review')) {
    url += '/review';
  }

  return axios
    .get(url, config)
    .then(response => {
      commit('addActiveSurvey', response.data);
    });
}

export const addInstanceInfo = ({ commit }, payload) => {
  let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}/info`;

  return axios
    .get(url)
    .then(response => {
      commit('addInstanceInfo', response.data);
    })
}

export const setActiveSectionId = ({ commit }, sectionId) => {
  commit('setActiveSectionId', sectionId);
  commit('setSectionViewedStatus', {
    id: Number(sectionId),
    viewed: true
  });
}

export const setNavSectionQuestionIds = ({ commit }, payload) => {
  commit('setNavSectionQuestionIds', payload);
}

export const setTargetSection = ({ commit }, payload) => {
  commit('clearTargetSectionId', payload.triggerSectionId);
  commit('setTargetSection', payload);
}

export const clearTargetSectionId = ({ commit }, sectionId) => {
  commit('clearTargetSectionId', sectionId);
}

function createLocalUserSurvey(data) {
  let localUserSurvey = {
    surveyUrlId: data.surveyUrlId,
    orgSurveyUserId: data.orgSurveyUserId
  };

  if(data.hasOwnProperty('token')) {
    localUserSurvey.token = data.token;
  }
  if (data.hasOwnProperty('validTo')) {
    localUserSurvey.validTo = data.validTo;
  }

  return localUserSurvey;
}

function getLocalUserBySurveyId(surveyId) {
  let userIndex = -1;
  let localUserSurvey = null;
  let userSurveys = JSON.parse(localStorage.getItem('hspUserSurveys')) || [];

  userIndex = userSurveys.findIndex(userSurvey => userSurvey.surveyUrlId === surveyId);

  if(userIndex >= 0) {
    localUserSurvey = userSurveys[userIndex];
  }

  return localUserSurvey;
}

function addLocalUserSurvey(localUserSurvey) {
  let userIndex = -1;
  let userSurveys = JSON.parse(localStorage.getItem('hspUserSurveys')) || [];

  userIndex = userSurveys.findIndex(userSurvey => userSurvey.surveyUrlId === localUserSurvey.surveyUrlId);

  if(userIndex >= 0) {
    userSurveys.splice(userIndex, 1, localUserSurvey);
  }
  else {
    userSurveys.push(localUserSurvey);
  }

  localStorage.setItem('hspUserSurveys', JSON.stringify(userSurveys));
}

function deleteLocalUserSurvey(surveyId) {
  let userIndex = -1;
  let localUserSurvey = null;
  let userSurveys = JSON.parse(localStorage.getItem('hspUserSurveys')) || [];

  userIndex = userSurveys.findIndex(userSurvey => userSurvey.surveyUrlId === surveyId);

  if(userIndex >= 0) {
    userSurveys.splice(userIndex, 1);
  }

  localStorage.setItem('hspUserSurveys', JSON.stringify(userSurveys));
}

export const updateSurveyUser = ({ dispatch, commit }, payload) => {
  let localUserSurvey = getLocalUserBySurveyId(payload.surveyUrlId);
  let surveyUser = null;
  let localUserSurveyTemplate;

  if(!localUserSurvey) {
    let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}/users`;

    return axios
      .post(url, {
        "UserSurveyStatusId": payload.userSurveyStatusId
      })
      .then(response => {
        localUserSurveyTemplate = createLocalUserSurvey({
          surveyUrlId: payload.surveyUrlId,
          orgSurveyUserId: response.data.orgSurveyUserId
        });

        surveyUser = Object.assign({}, localUserSurveyTemplate, {
          userSurveyStatusId: response.data.userSurveyStatusId
        });

        commit('updateSurveyUser', surveyUser);
        addLocalUserSurvey(localUserSurveyTemplate);
      });
  }
  else {
    localUserSurveyTemplate = createLocalUserSurvey({
      surveyUrlId: localUserSurvey.surveyUrlId,
      orgSurveyUserId: localUserSurvey.orgSurveyUserId
    });

    surveyUser = Object.assign({}, localUserSurveyTemplate);
    addLocalUserSurvey(localUserSurveyTemplate);

    let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}/users/${surveyUser.orgSurveyUserId}`;

    return axios
      .get(url)
      .then(response => {
        Object.assign(surveyUser, response.data);
        commit('updateSurveyUser', surveyUser);
      })
      .catch((error) => {
        if(error.response && error.response.status === 404) {
          deleteLocalUserSurvey(payload.surveyUrlId);
          dispatch('updateSurveyUser', payload);
        }
        else {
          throw(error);
        }
      });
  }
}

export const getSurveyUser = async ({ commit }, payload) => {
  let localUserSurvey = getLocalUserBySurveyId(payload.surveyUrlId);

  if (localUserSurvey === null) {
    return null;
  }

  let surveyUser;
  let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}/users/${localUserSurvey.orgSurveyUserId}`;

  let response = await axios.get(url);
  surveyUser = Object.assign({}, response.data, localUserSurvey);
  commit('updateSurveyUser', surveyUser);

  return surveyUser;
}

export const authenticateUser = ({ commit }, payload) => {
  let localUserSurvey = getLocalUserBySurveyId(payload.surveyUrlId);
  let surveyUser;
  let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}/users/auth`;
  let postPayload = {
    "UserSurveyStatusId": 1,
    "SurveyAccessCode": payload.surveyAccessCode
  };

  if(localUserSurvey !== null) {
    postPayload.OrgSurveyUserId = localUserSurvey.orgSurveyUserId;
  }

  return axios
    .post(url, postPayload)
    .then(response => {
      localUserSurvey = createLocalUserSurvey({
        surveyUrlId: payload.surveyUrlId,
        orgSurveyUserId: response.data.surveyUser.orgSurveyUserId,
        token: response.data.surveyUser.token,
        validTo: response.data.validTo
      });

      surveyUser = Object.assign({}, localUserSurvey, response.data.surveyUser);
      commit('updateSurveyUser', surveyUser);
      addLocalUserSurvey(localUserSurvey);
    });
}

export const getAuthenticatedUser = async ({ commit }, payload) => {
  let localUserSurvey = getLocalUserBySurveyId(payload.surveyUrlId);

  if (localUserSurvey === null) {
    return null;
  }

  let surveyUser;
  let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}/users/${localUserSurvey.orgSurveyUserId}/auth`;
  let config = {
    headers: {
      'Authorization': `Bearer ${localUserSurvey.token}`
    }
  };

  let response = await axios.get(url, config);
  surveyUser = Object.assign({}, response.data, localUserSurvey);
  commit('updateSurveyUser', surveyUser);

  return surveyUser;
}

export const refreshToken = async ({ commit }, payload) => {
  let localUserSurvey = getLocalUserBySurveyId(payload.surveyUrlId);

  if (localUserSurvey === null) {
    return null;
  }

  let url = `${process.env.VUE_APP_API_URL}surveys/${payload.surveyUrlId}/users/${localUserSurvey.orgSurveyUserId}/auth/renew`;
  let config = {
    headers: {
      'Authorization': `Bearer ${localUserSurvey.token}`
    }
  };

  // Mutate the new token
  let response = await axios.get(url, config);
  commit('updateSurveyUserToken', { 
    token: response.data.surveyUser.token,
    validTo: response.data.validTo
  });

  // Update local storage data
  localUserSurvey.token = response.data.surveyUser.token;
  localUserSurvey.validTo = response.data.validTo;
  addLocalUserSurvey(localUserSurvey);

  return { newToken: response.data.surveyUser.token, validTo: response.data.validTo};
}

export const setUserStatus = ({ state, commit }, payload) => {
  if (state.surveyUser.userSurveyStatusId === payload.status) {
    return;
  }

  let url = `${process.env.VUE_APP_API_URL}surveys/${state.activeSurvey.surveyUrlId}/users/${state.surveyUser.orgSurveyUserId}`;
  let config = {};

  if(payload.hasOwnProperty('token')) {
    url += '/auth';
    config = {
      headers: {
        'Authorization': `Bearer ${payload.token}`
      }
    };
  }

  let data = [
    {
      "op": "add",
      "path": "/userSurveyStatusId",
      "value": payload.status
    }
  ];

  axios
  .patch(url, data, config)
  .then(() => commit('setUserStatus', payload));
}

export const setUserStatusAsync = async ({ state, commit }, payload) => {
  if(state.surveyUser.userSurveyStatusId === payload.status) {
    return;
  }

  let url = `${process.env.VUE_APP_API_URL}surveys/${state.activeSurvey.surveyUrlId}/users/${state.surveyUser.orgSurveyUserId}`;
  let config = {};

  if(payload.hasOwnProperty('token')) {
    url += '/auth';
    config = {
      headers: {
        'Authorization': `Bearer ${payload.token}`
      }
    };
  }

  let data = [
    {
      "op": "add",
      "path": "/userSurveyStatusId",
      "value": payload.status
    }
  ];

  let response = await axios.patch(url, data, config);

  // Default to no errors
  let errors = {
    error: "",
    responses: null
  };

  // If we're at the end of the survey but there are missing responses, set some error data
  // and mutate the state responses equal to the returned response data.
  if (payload.status === 4 && response.data.userSurveyStatusId < 4) {
    errors.error = "MissingResponse";

    // Initialize a local responses object with the store's responses object and merge/update
    // the responses data returned from the server.
    let responses = Object.assign({}, state.surveyUser.responses);
    responses = Object.assign(responses, response.data.userSurveyResponses);

    // Convert the local responses object to an array and set it to its corresponding field in the error object.
    errors.responses = Object.keys(responses).map((key) => ({ name: key, ...responses[key] }));

    // Get the response ID's from the server data.
    let responseIds = response.data.userSurveyResponses.map(x => x.userSurveyResponseId);

    // Filter out any responses that aren't (retrieved) from the server.
    errors.responses = errors.responses.filter(x => responseIds.indexOf(x.userSurveyResponseId) > -1);

    commit('setUserResponses', { responses: errors.responses });

    return errors;
  }

  commit('setUserStatus', payload)

  return errors;
}

export const setSurveyInitialized = ({ commit }, payload) => {
  commit('setSurveyInitialized', payload);
}

export const setQuestionResponse = ({ commit }, response) => {
  commit('setQuestionResponse', response);
};

export const setCheckboxesQuestionResponse = ({ commit }, response) => {
  commit('setCheckboxesQuestionResponse', response);
};

export const setCheckboxTextResponse = ({ commit }, response) => {
  commit('setCheckboxTextResponse', response);
};

export const setPreviousSection = ({ state, commit, dispatch }) => {
  let sectionIndex = state
    .activeSurveyNavSections
    .findIndex(section => section.id === state.activeSectionId);
  let activeSection = state.activeSurveyNavSections[sectionIndex];

  if(sectionIndex === 0) {
    // Active section is first section. No previous sections available.
    return;
  }

  commit('clearTargetSectionId', state.activeSectionId);
  sectionIndex--;
  //console.log(`-A ${sectionIndex}`)

  if(activeSection.triggerSectionId === null || sectionIndex === 0) {
    // No trigger section specified or first section.
    //console.log(`-B ${sectionIndex}`)
    dispatch('setActiveSectionId', state.activeSurveyNavSections[sectionIndex].id);
    return;
  }

  while(state.activeSurveyNavSections[sectionIndex].id !== activeSection.triggerSectionId && sectionIndex > 0) {
    sectionIndex--;
    //console.log(`-C ${sectionIndex}`)
  }

  dispatch('setActiveSectionId', state.activeSurveyNavSections[sectionIndex].id);
}

export const setNextSection = async ({ state, commit, dispatch }, payload) => {
  let sectionIndex = state
    .activeSurveyNavSections
    .findIndex(section => section.id === state.activeSectionId);
  let activeSection = state.activeSurveyNavSections[sectionIndex];
  let skippedQuestionIds = [];

  if(sectionIndex === state.activeSurveyNavSections.length - 1) {
    // Active section is last section. No additional sections available.
    // setActiveSectionId will set previous section id and the active section to null.
    dispatch('setActiveSectionId', null);
    return null;
  }

  sectionIndex++;
  //console.log(`+A ${sectionIndex}`)

  let nextSection = null;
  let completedMsg = null;
  if(activeSection.targetSectionId === null || sectionIndex === state.activeSurveyNavSections.length - 1) {
    // No target section specified or last section.
    //console.log(`+B ${sectionIndex}`);
    commit('clearTargetSectionId', state.activeSectionId);
    commit('setTargetSection', {
      triggerSectionId: state.activeSectionId,
      targetSectionId: state.activeSurveyNavSections[sectionIndex].id
    });
    dispatch('setActiveSectionId', state.activeSurveyNavSections[sectionIndex].id);

    // Check for custom end of survey message
    if (activeSection.targetSectionId !== null) {
      nextSection = state.activeSurvey.sections.find(x => x.hspSectionId === activeSection.targetSectionId);
      completedMsg = completedMessage(nextSection);
      if (!isNullOrEmpty(completedMsg)) {   
        return completedMsg;
      }
    }

    return null;
  }

  while(state.activeSurveyNavSections[sectionIndex].id !== activeSection.targetSectionId && (sectionIndex + 1) < state.activeSurveyNavSections.length) {
    let section = state.activeSurveyNavSections[sectionIndex];
    skippedQuestionIds = skippedQuestionIds.concat(section.questionIds);
    commit('setSectionViewedStatus', {
      id: section.id,
      viewed: false
    });
    sectionIndex++;
    //console.log(`+C ${sectionIndex}`)
  }
  activeSection = state.activeSurveyNavSections[sectionIndex];

  if(state.surveyUser.orgSurveyUserId !== null && skippedQuestionIds.length) {
    deleteResponses(state, commit, skippedQuestionIds, payload);
  }

  commit('clearTargetSectionId', state.activeSectionId);
  commit('setTargetSection', {
    triggerSectionId: state.activeSectionId,
    targetSectionId: activeSection.id
  });

  // If the next section has a custom completed message, don't update/mutate to the next section since we are going to end the survey,
  // i.e., returning the completedMsg signifies the end of the survey, and its used to route to the 'Completed' page. 
  nextSection = state.activeSurvey.sections.find(x => x.hspSectionId === activeSection.id);
  completedMsg = completedMessage(nextSection);
  if (!isNullOrEmpty(completedMsg)) {
    return completedMsg;
  }

  dispatch('setActiveSectionId', activeSection.id);
  return null;
}

export const setSection = ({ state, commit, dispatch }, payload) => {
  let sectionIndex = state
    .activeSurveyNavSections
    .findIndex(section => section.id === payload.targetSectionId);

  // return if section isn't found.
  if (sectionIndex < 0) {
    return;
  }
  let targetSection = state.activeSurveyNavSections[sectionIndex];

  // Find the target section's trigger section
  let triggerSection = state.activeSurveyNavSections.find(section => section.targetSectionId === targetSection.id);

  // The trigger section, from normal single session navigation, might not exist (is null) if the session has timed out, user has re-logged 
  // back into subsequent session(s), or the user has refreshed the browser. So, try finding the trigger section ID in the following order:
  // 1) the trigger section ID (triggerSection.id) found from the target section ID (targetSection.id), 
  // 2) the target section's trigger section ID (targetSection.triggerSectionId)
  // 3) the payload's trigger section ID (payload.triggerSectionId)
  // 4) the store state's active section ID (state.activeSectionId)
  let triggerSectionId = 
    triggerSection ? triggerSection.id                                  // 1) trigger section found from target section
    : targetSection.triggerSectionId ? targetSection.triggerSectionId   // 2) the target section's triggerSectionId if '1' was not found
    : payload.triggerSectionId ? payload.triggerSectionId               // 3) Use the payload's triggerSectionId if '2' is null
    : state.activeSectionId;                                            // 4) Use the activeSectionId if '3' is null

  if (state.activeSectionId !== null) {
    commit('clearTargetSectionId', state.activeSectionId);
  }
  commit('setTargetSection', {
    triggerSectionId: triggerSectionId,
    targetSectionId: targetSection.id
  });
  dispatch('setActiveSectionId', targetSection.id);
}

function deleteResponses(state, commit, responses, payload) {
  let surveyId = state.activeSurvey.surveyUrlId;
  let userId = state.surveyUser.orgSurveyUserId;
  let url = `${process.env.VUE_APP_API_URL}surveys/${surveyId}/users/${userId}/responses`;
  let config = {};

  if (payload && payload.hasOwnProperty('token')) {
    url += '/auth';
    config['headers'] = {
      'Authorization': `Bearer ${payload.token}`
    };
  }

  let userResponses = responses.map(response => {
    return {
      "HspCategoryQuestionId": response
    };
  });

  config['data'] = userResponses;
  axios.delete(url, config)
    .then(() => commit('deleteResponses', { hspCategoryQuestionIds: responses }));
}

export const addStatistics = ({ commit }, payload) => {
  let url = `${process.env.VUE_APP_API_URL}reporting/${payload.surveyUrlId}/statistics`;

  return axios
    .get(url)
    .then(response => {
      commit('addStatistics', response.data);
    });
}

export const verifyRecaptcha = async ({ state }, payload) => {
  let url = `${process.env.VUE_APP_API_URL}surveys/${state.activeSurvey.surveyUrlId}/users/recaptcha`;
  let isSecure = typeof state.surveyUser.token !== "undefined" && state.surveyUser.token !== null ? true : false;
  payload.IsSecure = isSecure;
  payload.OrgSurveyUserId = state.surveyUser.orgSurveyUserId;
  let response = await axios.post(url, payload);

  return response.data;
}

// Admin Actions
export const addAuthenticatedUser = ({ commit }, payload) => {
  let url = `${process.env.VUE_APP_API_URL}admin/users/signin`;

  return axios
    .post(url, payload)
    .then(response => {
      if (!Array.isArray(response.data.user.roles)) {
        response.data.user.roles = [];
      }

      commit('addAuthenticatedUser', response.data);
    });
}
